module.exports = __webpack_public_path__ + "static/img/Giants.bb4593f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Giants.png
// module id = EFQB
// module chunks = 1